import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { API } from '../api';

/**
 * Adds only the required P0 subscription key header to outbound requests that target the P0 API base.
 */
export const p0SubscriptionKeyInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
) => {
	// Apply only for P0 API base requests and if no subscription key header is already present
	if (!req.url.startsWith(API.base) || req.headers.has('P0-Subscription-Key')) {
		return next(req);
	}

	const cloned = req.clone({ setHeaders: { 'P0-Subscription-Key': API.p0SubscriptionKey } });

	return next(cloned);
};
